<template>
  <div class="location-component">
    <div class="main-container">
      <div @click="showLocation" class="title">Add Location</div>
      <div @click="showLocation" class="right-container">
        <el-popover
          placement="bottom"
          width="230"
          v-model="showModal"
          trigger="manual"
        >
          <div class="location-search-modal">
            <div class="search-header">
              <div class="search-input" ref="location">
                <input placeholder="Search" v-model="searchText" />
                <div @click="querySearchAsync" class="search-icon-container">
                  <div class="search-icon"></div>
                </div>
              </div>
            </div>
            <div class="search-result-container">
              <div class="loading" v-show="loading">
                <i class="el-icon-loading"></i>
              </div>
              <div
                class="search-item"
                @click="handleSelect(model)"
                v-for="model in locationList"
                :key="model.id"
              >
                <div class="image-container location">
                  <div class="image"></div>
                </div>
                <div class="right-container">
                  <div class="first-container">
                    <div class="title">{{ model.name }}</div>
                  </div>
                  <div class="des">{{ model.address }}</div>
                </div>
              </div>
            </div>
          </div>
          <el-input
            :readonly="true"
            v-model="location"
            placeholder="None"
            slot="reference"
          ></el-input>
        </el-popover>
      </div>
      <div class="clear-icon" @click="clear" v-if="location"></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";
.location-component {
  border-bottom: 1px solid #e5e5e5;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .search-header {
    display: flex;
    align-items: center;
  }

  .main-container {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    align-items: center;
    .title {
      font-size: 14px;
    }

    .right-container {
      flex: 1;
      text-align: right;
      padding-left: 20px;
      .location-input {
        width: 200px;
        input:read-only {
          cursor: pointer !important;
        }
      }
    }
  }
  .clear-icon {
    margin-left: 10px;
    background-image: url("../../../../../public/images/crop/Close.png");
    background-size: contain;
    height: 15px;
    width: 15px;
    cursor: pointer;
    &:hover,
    &:active {
      opacity: 0.3;
    }
  }
}
</style>
<style lang="less">
@import "../../../../assets/style/theme";
.location-component .main-container input.el-input__inner {
  padding: 0;
  border-color: transparent;
  text-align: right;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.location-component {
  input:read-only {
    cursor: pointer !important;
  }
}
.location-search-modal {
  padding: 10px 0;
  .search-header {
    display: flex;
    margin: 0 10px;
    .search-input {
      border: 1px solid @border-color;
      border-radius: 4px;
      height: 36px;
      display: flex;
      align-items: center;
      padding: 0 5px;
      flex: 1;
      input {
        font-size: 12px;
        border: 0;
        flex: 1;
      }
    }
    .search-icon-container {
      height: 27px;
      width: 27px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: contain;
      background-image: url("../../../../../public/images/schedule_posts/location@3x.png");
      cursor: pointer;
      &:hover,
      &:active {
        opacity: 0.8;
      }
    }
  }
  .location-container {
    overflow: auto;
    display: flex;
    height: 53px;
    align-items: center;

    .item {
      padding: 0 7px;
      background: #e5e5e5;
      border-radius: 2px;
      white-space: nowrap;
      margin-right: 10px;
      font-size: 12px;
      cursor: pointer;
      height: 24px;
      line-height: 24px;
    }
  }
  .search-result-container {
    overflow: auto;
    flex: 1;
    height: 200px;
    max-height: 200px;
    .loading {
      padding: 5px 15px;
      color: @font-color-gray;

      i {
        font-size: 20px;
      }

      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .search-item {
      height: 60px;
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 100%;
      padding: 0 10px;
      &:hover,
      &:active {
        background: rgba(0, 0, 0, 0.1);
      }

      .image-container {
        background: white;
        border: 1px solid #cccccc;
        height: 32px;
        width: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .image {
          background-image: url("../../../../../public/images/repost/icon_place@3x.png");
          height: 30px;
          width: 30px;
          background-size: contain;
          border-radius: 50%;
          border: 2px solid white;
        }
      }
    }
    .right-container {
      flex: 1;
      align-items: center;
      padding: 0 10px;
      width: 130px;

      .first-container {
        display: flex;
        align-items: center;

        .title {
          font-size: 14px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .des {
        font-size: 12px;
        color: @font-color-gray;
        margin-top: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
<script>
import { location } from "../../../../service/instagram";
import { showErrorMsg } from "../../../../utils/errors";
import { permissionValidate } from "../../../../service/publisher";
import { mapGetters } from "vuex";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";
export default {
  name: "CalenderScheduleFormLocationComponent",
  model: {
    prop: "value",
    event: "updateValue",
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    validate: {
      // 校验权限是否通过
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
  },
  data() {
    return {
      locationList: [],
      searchText: "",
      loading: false,
      showModal: false, // 弹出是否展示
      location: this.value ? this.value.name : "",
    };
  },
  watch: {
    value(val) {
      this.location = val.name;
    },
  },
  methods: {
    async querySearchAsync() {
      try {
        this.loading = true;
        this.locationList = await location({ q: this.searchText });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.loading = false;
      }
    },
    async showLocation() {
      if (this.validate) {
        this.showModal = true;
      } else {
        await permissionValidate({ type: "full" });
      }
    },
    // 清空选项
    clear() {
      this.location = null;
      this.$emit("updateValue", null);
      this.showModal = false;
    },
    handleSelect(item) {
      this.location = item.value;
      console.log("handleSelect", item);
      this.$emit("updateValue", item);
      this.showModal = false;
    },
  },
  async created() {
    this.locationList = [];
    // 如果开启定位权限自动获取地理信息
  },
};
</script>
